// Components
import EditBox from 'Components/EditBox'

export default {
  components: {
    EditBox,
  },

  data() {
    return {
      isEditing: false,
    }
  },

  computed: {
    hideOnEdit() {
      return this.isEditing && 'hide-on-edit'
    },
  },

  methods: {
    openEditBox() {
      if (!this.isEmployee && !this.isEditPage && this.isTemplatePage) return
      this.isEditing = true
    },

    closeEditBox() {
      this.isEditing = false
    },
  },
}
